/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
//import { useParams } from "react-router-dom";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Dialog } from 'primereact/dialog';

//*************** Libreria para realizar pdfs**************************************//
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE--------------------------
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { formatDate, formatFecha} from "../../../../../Base/Services/FechasService";

// ------------------- CONSULTAS A LA API---------------------------
import { getProveedorInfoPorId, getRegistrosExonerados } from "../../../../../API/Compras/Proveedores/ProveedoresRequest";
import { getInformacionEmpresaPublic } from "../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { FormatoInscripcionLang } from "./FormatoInscripcionLang";


pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FormatoInscripcionPDF = ({
  setShowDialogFormato,
  showDialogFormato,
  Numero,
  Idioma,
  Token
}) => {

  //const {Numero, Idioma, Token} = useParams();
  const [pdfUrl, setPdfUrl] = useState(null);

  const obtenerInformacion = async (Numero, Idioma, Token) => {
    const info = await getProveedorInfoPorId(Numero, Token);
    const registros = await getRegistrosExonerados(info?.[0]?.IdVendor, Token);
    const infoEmpresaT = await getInformacionEmpresaPublic(Token);
    const infoEmpresa = Array.isArray(infoEmpresaT) ? infoEmpresaT[0] : {};

    let IdLanguage = Idioma === "en" || Number(Idioma) === 1 ? 1 : 2;

    const toBool = (value) => {
      return value === true || value === 1 || value === "1";
    };

    const registroFiscal = Array.isArray(registros)
      ? registros.find(x => x.IdEstado === 5) || registros[0]
      : null;

    const proveedor = {
      ...info[0],
      ...(registroFiscal || {}),

      // Normalizamos nombres para que el PDF entienda el modo fiscal
      ZonaLibre: toBool(registroFiscal?.Zoli ?? info?.[0]?.ZonaLibre),
      TieneConstPagosCuenta: toBool(registroFiscal?.TieneConstPagosCuenta),
      SinRegistroExonerado: toBool(registroFiscal?.SinRegistroExonerado) ||
      (
        toBool(registroFiscal?.Zoli ?? info?.[0]?.ZonaLibre) &&
        !registroFiscal?.RegistroExonerado &&
        !registroFiscal?.RegistroExoneradoName
      ),

      // Normalizamos fechas
      StartDate: registroFiscal?.StartDate || registroFiscal?.FechaInicio || "",
      ExpiredDate:
        registroFiscal?.ExpiredDate ||
        registroFiscal?.FechaVencimientoStr ||
        registroFiscal?.FechaVencimiento ||
        "",
    };

    generarPDF(proveedor, IdLanguage, Idioma, infoEmpresa);
  };

  useEffect(() => {
    if (Numero) {
      obtenerInformacion(Numero, Idioma, Token);
    }
  }, [Numero, Idioma, Token]);

  
  const getImagePDF = (img) => {
    if (!img || typeof img !== "string") return null;
    const limpia = img.trim();
    if (!limpia) return null;
    if (limpia.startsWith("data:image/")) {
      return limpia;
    }
    return `data:image/png;base64,${limpia}`;
  };

  const generarPDF = async (info, Idioma, idiomaTexto, infoEmpresa = {}) => {
    let Language = Idioma === 1 ? 'en' : 'es'

    const logoEmpresa = getImagePDF(infoEmpresa?.LogoPrimarioH64 || infoEmpresa?.LogoPrimarioH || infoEmpresa?.LogoPrimario || infoEmpresa?.LogoPrimarioVertical || "" );
    const nombreEmpresa =infoEmpresa?.NombreLegal || infoEmpresa?.NombreEmpresa || "";
    const direccionEmpresa = infoEmpresa?.Direccion || "";
    const correoEmpresa = infoEmpresa?.CorreoInformativo || infoEmpresa?.CorreoCompras || infoEmpresa?.CorreoVentas || "";
    const telefonoEmpresa = infoEmpresa?.Telefono || "";
    const idPaisCuentaBancaria = Number(info?.IdPaisCuentaBancaria || info?.BancoPais || info?.IdCountry || 0);
    const isLocalBank = idPaisCuentaBancaria === 95;

    console.log("INFO PDF FECHAS:", {
      FechaLlenoFormato: info?.FechaLlenoFormato,
      DateCreate: info?.DateCreate,
      DateUpdate: info?.DateUpdate,
    });
    const formatMoney = (value) => value ?? "";
    // const label = (key, fallback) => getLabel(FormatoInscripcionLang, key, Language) || fallback;
    let modoFiscal = "";

    if (info?.ZonaLibre) {
      if (info?.SinRegistroExonerado) {
        modoFiscal = "MODO 1: Zona Libre SIN registro exonerado";
      } else {
        modoFiscal = "MODO 2: Zona Libre CON registro exonerado";
      }
    } else {
      if (info?.TieneConstPagosCuenta) {
        modoFiscal = "MODO 3: Constancia de Pagos a Cuenta";
      } else {
        modoFiscal = "MODO 4: Sin Zona Libre y sin Constancia";
      }
    }

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [30, 95, 30, 80],

      //HEADER
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              logoEmpresa
                ? {
                    image: logoEmpresa,
                    width: 200,
                    margin: [4, -10, -10, -10],
                  }
                : {
                    text: "",
                    width: 200,
                    margin: [4, -10, -10, -10],
                  },

              [
                {
                  text: nombreEmpresa,
                  style: "titulo",
                  margin: [-10, 20, 0, 0],
                  width: 350,
                },
                {
                  text: direccionEmpresa,
                  style: "titulo",
                  margin: [-10, 3, 0, 0],
                  width: 350,
                },
                {
                  text: correoEmpresa ? `E-mail: ${correoEmpresa}` : "",
                  style: "textBody1",
                  margin: [-10, 2, 0, 0],
                },
                {
                  text: telefonoEmpresa ? `Teléfono: ${telefonoEmpresa}` : "",
                  style: "textBody1",
                  margin: [-10, 2, 0, 0],
                },
              ],
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "codigoP",
                    Language
                  )} \n ${info?.CodigoProveedor || ''}`,
                  style: "numeroDoc",
                  width: 100,
                  margin: [0, 35, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      //FOOTER
      footer: (currentPage, pageCount) => {
        const footerContent = [
          {
            text: `${getLabel(FormatoInscripcionLang, "textFinal", Language)}`,
            margin: [25, 10, 25, 0],
            fontSize: 8,
            alignment: "justify",
          },
          {
            text: `${getLabel(FormatoInscripcionLang, "textFinal1", Language)}`,
            margin: [25, 0, 25, 0],
            fontSize: 8,
          },
          {
            text: `Impreso: ${formatDate(new Date())}`,
            alignment: "right",
            fontSize: 8,
            margin: [0, 0, 25, 0],
          },
        ];

        if (info?.UsuarioReviso) {
          footerContent.push({
            columns: [
              {
                text: `${getLabel(FormatoInscripcionLang, "revisadoPor", Language)}: ${info.UsuarioReviso}`,
                fontSize: 8,
                alignment: "right",
                margin: [0, 0, 25, 0],
              },
            ],
          });
        }

        if (info?.FechaRevision) {
          footerContent.push({
            columns: [
              {
                text: `${getLabel(FormatoInscripcionLang, "fechaRevision", Language)}: ${info.FechaRevision}`,
                fontSize: 8,
                alignment: "right",
                margin: [0, 1.5, 25, 0],
              },
            ],
          });
        }

        return footerContent;
      },

      //CONTENIDO
      content: [
        {
          columns: [
            {
              text: info?.DateUpdate
                ? `Fecha llenó formato: ${formatDate(new Date(info.DateUpdate))}`
                : "",
              fontSize: 8,
              alignment: "left",
              width: "*",
            },
          ],
          margin: [0, 0, 0, 5],
        },
        {
          columns: [
            {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "textInicial",
                        Language
                      )}`,
                      border: [false, true, false, true],
                      style: "subtitle",
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: function (i) {
                  return 0.05;
                },
              },
            },
          ],
        },
        {
          columns: [
            {
              margin: [0, 5, 0, 0],
              table: {
                widths: ["15%", "33%", "2%", '33%', '2%', '15%'],
                body: [
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang,"tipoSolicitud",Language)}`,
                      border: [false, false, false, false],
                      style: "subtitle2",
                    },
                    {
                      text: `${getLabel(FormatoInscripcionLang, "inscripcion", Language )}`,
                      border: [false, false, false, false],
                      style: "subtitle3",
                    },
                    {
                      text: ``,
                      border: [true, true, true, true],
                      style: "subtitle2",
                    },
                    {
                      text: `${getLabel(FormatoInscripcionLang,"actualizacion",Language)}`,
                      border: [false, false, false, false],
                      style: "subtitle3",
                    },
                    {
                      text: ``,
                      border: [true, true, true, true],
                      style: "subtitle2",
                    },
                    {
                      text: ``,
                      border: [false, false, false, false],
                      style: "subtitle2",
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: function (i) {
                  return 0.05;
                },
                vLineWidth: function (i) {
                  return 0.05; 
                },
              },
            },
          ],
        },

        // PARTE I
        {
          margin: [0, 15, 0, 0],
          style: "tableExample",
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "parteI",
                    Language
                  )}`,
                  style: "subtitle",
                  border: [false, false, false, false],
                  fillColor: "#0864cc",
                  color: "white", // Color del texto blanco
                },
              ],
            ],
          },
        },
        {
          margin: [0, 10, 0, 0],
          table: {
            widths: ["55%", "3%", "42%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "casaMatriz",
                    Language
                  )}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `${getLabel(FormatoInscripcionLang, "pais", Language)}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `${info?.CasaMatriz || info?.CustomerName || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.Country || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],

              [
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `${getLabel(FormatoInscripcionLang, "identificacionTributaria", Language)}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],

              [
                {
                  text: `${getLabel(FormatoInscripcionLang, "nombre", Language)}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `RTN/RUC/UTR/BRN/TAX ID`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `${info?.NombreComercial || info?.CustomerName || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.RTN || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],

              [
                {
                  text: `${getLabel(FormatoInscripcionLang, "direccionC", Language)}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
              ],
              [
                {
                  text: `${info?.DireccionCasaMatriz || info?.Address || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["5%", "44%", "12%", "39%"],
            body: [
              [
                {
                  text: `${getLabel(FormatoInscripcionLang,"nTel",Language)}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `No.`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.Telefono || info?.Tel || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `E-mail:`,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.Email || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],


            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["8%", "41%", "12%", "39%"],
            body: [
              [
                {
                  text: `${getLabel(FormatoInscripcionLang,"contacto",Language)}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Nombre: `,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ContactoCuentasPorCobrar || ''}`,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.CorreoCuentasPorCobrar || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],

              [
                {
                  text: `${getLabel(FormatoInscripcionLang,"representanteL",Language)}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Nombre: `,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.NombreRepresentanteLegal || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.CorreoRepresentanteLegal || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],

              [
                {
                  text: `${getLabel(FormatoInscripcionLang,"actividad",Language)}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `${info?.PrincipalActividadEconomica || ''}`,
                  colSpan: 4,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody2",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],

            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },

        // PARTE II
        {
          style: "tableExample",     
          margin: [0, 20, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "parteII",
                    Language
                  )}`,
                  style: "subtitle",
                  border: [false, false, false, false],
                  margin: [0, 0, 0, 0],
                  fillColor: "#0864cc",
                  color: "white", // Color del texto blanco
                },
              ],
            ],
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["5%", "44%", "12%", "39%"],
            body: [
              [
                {
                  text: [
                    { text: `${getLabel(FormatoInscripcionLang,"nombreC",Language)}: ` },
                    { text: `${info?.ref1Nombre || ""}`, bold: false },
                  ],
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  margin: [0, 5, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  margin: [0, 5, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Tel.`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref1Telefono || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref1Correo || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],


            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },    
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["5%", "44%", "12%", "39%"],
            body: [
              [
                {
                  text: [
                    { text: `${getLabel(FormatoInscripcionLang,"nombreC",Language)}: ` },
                    { text: `${info?.ref2Nombre || ""}`, bold: false },
                  ],
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  margin: [0, 8, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Tel.`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref2Telefono || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref2Correo || ''}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],


            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },

        // PARTE III
        {
          margin: [0, 20, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(FormatoInscripcionLang, "parteIII", Language)}`,
                  style: "subtitle",
                  border: [false, false, false, false],
                  margin: [0, 0, 0, 0],
                  fillColor: "#0864cc",
                  color: "white",
                },
              ],
            ],
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(FormatoInscripcionLang, "text3", Language)}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
              ],
            ],
          },
        },

        isLocalBank
          ? {
              margin: [0, 5, 0, 0],
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "bancoNacional",
                        Language
                      )}`,
                      style: "subtitle",
                      border: [false, false, false, false],
                      margin: [0, -5, 0, 0],
                    },
                  ],
                ],
              },
            }
          : null,

        isLocalBank
          ? {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["30%", "70%"],
                body: [
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "cuentaBancariaNacional",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 0, 0, 0],
                    },
                    {
                      text: `${info?.NumeroCuentaBancaria || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "aNombreDe",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.TitularCuenta || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "Banco",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.NombreBanco || info?.Banco || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "RTN",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.RTN || info?.numeroIdentificacionTributaria || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    { text: "" },
                    {
                      text: "",
                      pageBreak: "after",
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "tipoCuenta",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.TipoCuenta || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "Moneda",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.Currency || info?.CurrencyName || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "CorreoNotificacionPago",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.CorreoCuentasPorCobrar || info?.Email || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "TelefonoSmall",
                        Language
                      )}`,
                      style: "textBody1",
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.TelefonoCuentasPorCobrar || info?.Telefono || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
                hLineWidth: () => 0.03,
                vLineWidth: () => 0.03,
              },
            }
          : null,

        isLocalBank && info?.FormaPagoBanco === "DeduccionACH"
          ? {
              text: `${getLabel(
                FormatoInscripcionLang,
                "deduccionACH",
                Language
              )}`,
              style: "textBody1",
              bold: true,
              alignment: "center",
              fontSize: 9,
              margin: [0, 12, 0, 4],
            }
          : null,

        isLocalBank && info?.FormaPagoBanco === "PagarCheque"
        ? {
            text: `${getLabel(
              FormatoInscripcionLang,
              "pagoCheque",
              Language
            )}`,
            style: "textBody1",
            bold: true,
            alignment: "center",
            fontSize: 9,
            margin: [0, 12, 0, 4],
          }
        : null,

        !isLocalBank
          ? {
              margin: [0, 10, 0, 0],
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "bancoI", Language)}`,
                      style: "subtitle",
                      border: [false, false, false, false],
                      margin: [0, -5, 0, 0],
                    },
                  ],
                ],
              },
            }
          : null,

        !isLocalBank
          ? {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["15%", "85%"],
                body: [
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "nombreB", Language)}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 0, 0, 0],
                    },
                    {
                      text: `${info?.BancoIntermediarioNombre || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "direccionB", Language)}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoIntermediarioDireccion || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "numeroCuenta", Language)}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoIntermediarioCuenta || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: () => 0.03,
                vLineWidth: () => 0.03,
              },
            }
          : null,

        !isLocalBank
          ? {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["5%", "44%", "11%", "40%"],
                body: [
                  [
                    {
                      text: "Swift:",
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoIntermediarioSwift || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: "ABA:",
                      style: "textBody2",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoIntermediarioAbaBin || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: () => 0.03,
                vLineWidth: () => 0.03,
              },
            }
          : null,

        !isLocalBank
          ? {
              margin: [0, 50, 0, 0],
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "bancoB", Language)}`,
                      style: "subtitle",
                      border: [false, false, false, false],
                      margin: [0, -5, 0, 0],
                    },
                  ],
                ],
              },
            }
          : null,

        !isLocalBank
          ? {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["18%", "82%"],
                body: [
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "nombreBeneficiario", Language)}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 0, 0, 0],
                    },
                    {
                      text: `${info?.BancoBeneficiarioNombreBeneficiario || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "nombreB", Language)}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoBeneficiarioNombre || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "direccionB", Language)}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoBeneficiarioDireccion || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "numeroCuenta", Language)}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoBeneficiarioCuenta || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: () => 0.03,
                vLineWidth: () => 0.03,
              },
            }
          : null,

        !isLocalBank
          ? {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["5%", "44%", "11%", "40%"],
                body: [
                  [
                    {
                      text: "Swift:",
                      style: "textBody1",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoBeneficiarioSwift || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: "ABA:",
                      style: "textBody2",
                      border: [false, false, false, false],
                      margin: [0, 5, 0, 0],
                    },
                    {
                      text: `${info?.BancoBeneficiarioAbaBin || ""}`,
                      style: "textBody5",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: () => 0.03,
                vLineWidth: () => 0.03,
              },
            }
          : null,


        // PARTE IV
        {
          style: "tables2",
          margin: [0, 20, 0, 0],
          table: {
            widths: [80, "*", 70, "*"],
            body: [
              [
                {
                  text: `${getLabel(FormatoInscripcionLang, "parteIV", Language)}`,
                  style: "subtitle",
                  border: [false, false, false, false],
                  fillColor: "#0864cc",
                  color: "white",
                  colSpan: 4,
                },
                {}, {}, {},
              ],
              [
                {
                  text: [
                    { text: `${getLabel(FormatoInscripcionLang, "Moneda", Language) + ':  '}`, bold: true },
                    { text: `${info?.CurrencyFinName || info?.CurrencyFin || ""}`, bold: false },
                  ],
                  colSpan: 4,
                  margin: [0, 5, 0, 0],
                },
                {}, {}, {},
              ],
              [
                { text: `${getLabel(FormatoInscripcionLang, 'ActivoCorriente', Language)}: `, bold: true, margin: [0, 5, 0, 0], },
                { text: `${formatMoney(info?.ActivosCorrientes)}`, border: [false, false, false, true], alignment: "center", margin: [0, 5, 0, 0] },
                { text: `${getLabel(FormatoInscripcionLang, 'TotalActivo', Language)}: `, bold: true, margin: [0, 5, 0, 0], },
                { text: `${formatMoney(info?.TotalActivos)}`, border: [false, false, false, true], alignment: "center", margin: [0, 5, 0, 0] },
              ],
              [
                { text: `${getLabel(FormatoInscripcionLang, 'PasivoCorriente', Language)}: `, style: "textBody1", margin: [0, 5, 0, 0], },
                { text: `${formatMoney(info?.PasivosCorrientes)}`, border: [false, false, false, true], alignment: "center", margin: [0, 5, 0, 0] },
                { text: `${getLabel(FormatoInscripcionLang, 'TotalPasivo', Language)}: `, bold: true, margin: [0, 5, 0, 0], },
                { text: `${formatMoney(info?.TotalPasivos)}`, border: [false, false, false, true], alignment: "center", margin: [0, 5, 0, 0] },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
            hLineWidth: () => 0.05,
          },
        },

        // PARTE V
        info?.IdCountry === 95
          ? [
              {
                style: "textBody1",
                margin: [0, 25, 0, 0],
                table: {
                  widths: [80, "*", 50, "*"],
                  body: [[
                    {
                      text: `${getLabel(FormatoInscripcionLang, "parteV", Language)}`,
                      style: "subtitle",
                      border: [false, false, false, false],
                      fillColor: "#0864cc",
                      color: "white",
                      colSpan: 4,
                    },
                    { text: "" }, { text: "" }, { text: "" },
                  ]], text: `${getLabel(FormatoInscripcionLang, "FechaVencimiento", Language)}:`,
                },
                layout: { defaultBorder: false, hLineWidth: () => 0.05 },
              },

              info?.ZonaLibre
                ? info?.SinRegistroExonerado
                  ? {
                      text: `${getLabel(FormatoInscripcionLang, "msjZonaLibre", Language)}`,
                      margin: [10, 5, 10, 0],
                      alignment: "center",
                      style: "textBody1",
                      lineHeight: 1.5,
                    }
                  : {
                      margin: [0, 10, 0, 0],
                      style: "tables2",
                      table: {
                        widths: [60, 50, "*", 45, 70, 70, 70],
                        body: [
                          [
                            { text: `${getLabel(FormatoInscripcionLang, "RegistroExonerado", Language)}:`, colSpan: 2, style: "textBody1", margin: [0, 5, 0, 0] },
                            {},
                            { text: `${info?.RegistroExonerado || ""}`, border: [false, false, false, true], style: "textBody1SinBold", alignment: "center", margin: [0, 5, 0, 0] },
                            { text: `${getLabel(FormatoInscripcionLang, "FechaInicio", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                            { text: `${info?.StartDate || info?.FechaInicio || ""}`, border: [false, false, false, true], style: "textBody1SinBold", alignment: "center", margin: [0, 5, 0, 0] },
                            { text: `${getLabel(FormatoInscripcionLang, "FechaVencimiento", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                            { text: `${info?.ExpiredDate || info?.FechaVencimientoStr || info?.FechaVencimiento || ""}`, border: [false, false, false, true], style: "textBody1SinBold", alignment: "center", margin: [0, 5, 0, 0] },
                          ],
                          [
                            { text: `${getLabel(FormatoInscripcionLang, "nombreZona", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                            { text: `${info?.NombreZona || ""}`, colSpan: 6, border: [false, false, false, true], style: "textBody1SinBold", margin: [0, 5, 0, 0] },
                            {}, {}, {}, {}, {},
                          ],
                          [
                            { text: `${getLabel(FormatoInscripcionLang, "direccionZona", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                            { text: `${info?.DireccionZona || ""}`, colSpan: 6, border: [false, false, false, true], style: "textBody1SinBold", margin: [0, 5, 0, 0] },
                            {}, {}, {}, {}, {},
                          ],
                        ],
                      },
                      layout: { defaultBorder: false, hLineWidth: () => 0.05 },
                    }
                : !info?.TieneConstPagosCuenta
                  ? {
                      text: `${getLabel(FormatoInscripcionLang, "msjZonaLibre", Language)}`,
                      margin: [10, 5, 10, 0],
                      alignment: "center",
                      style: "textBody1",
                      lineHeight: 1.5,
                    }
                  : {
                      margin: [0, 10, 0, 0],
                      style: "tables2",
                      table: {
                        widths: [50, 150, "*", 70, 150],
                        body: [
                          [
                            { text: `${getLabel(FormatoInscripcionLang, "tieneConstanciaPagos", Language)}`, colSpan: 5, bold: true },
                            { text: "" }, { text: "" }, { text: "" }, { text: "" },
                          ],
                          [
                            { text: `${getLabel(FormatoInscripcionLang, "FechaInicio", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                            { text: `${info?.StartDate || info?.FechaInicio || ""}`, border: [false, false, false, true], style: "textBody1SinBold", alignment: "center", margin: [0, 5, 0, 0] },
                            { text: "" },
                            { text: `${getLabel(FormatoInscripcionLang, "FechaVencimiento", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                            { text: `${info?.ExpiredDate || info?.FechaVencimientoStr || info?.FechaVencimiento || ""}`, border: [false, false, false, true], style: "textBody1SinBold", alignment: "center", margin: [0, 5, 0, 0] },
                          ],
                        ],
                      },
                      layout: { defaultBorder: false, hLineWidth: () => 0.05 },
                    },
            ]
          : null,

          
        //FIRMA  
        {
          margin: [0, 80, 0, 0],
          columns: [
            { width: "*", text: "" },
            {
              width: "auto",
              stack: [
                {
                  text: "__________________________________________",
                  alignment: "center",
                  border: [false, false, false, false],
                },
                {
                  text: `${info?.CustomerName || info?.NombreComercial || ""}`,
                  alignment: "center",
                  style: "textBody1",
                  margin: [0, 5, 0, 0],
                },
              ],
            },
            { width: "*", text: "" },
          ],
        },
         
      ],

      // ESTILOS
      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        titulo: {
          fontSize: 8,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        requisa: {
          fontSize: 15,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        numeroDoc: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
        subtitle: {
          fontSize: 8,
          bold: true,
          alignment: "center",
        },
        subtitle2: {
          fontSize: 8,
          bold: true,
        },
        subtitle3: {
          fontSize: 8,
          bold: true,  
          alignment: "right",
        },
        infoGeneral: {
          fontSize: 7,
          margin: [-5, 0, 0, 0],
          // bold: true,
          // alignment: 'justify'
        },
        infoProveedor: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
        header: {
          fontSize: 6.5,
          alignment: "center",
          bold: true,
        },
        headerr: {
          fontSize: 7,
          margin: [-5, 0, 0, 0],
        },
        textBody1: {
          fontSize: 7.5,
          bold: true
          // alignment: "center",
          // lineHeight: 2
        },
        textBody5: {
          fontSize: 7.5,
          // alignment: "center",
          // lineHeight: 2
        },
        textBody2: {
          fontSize: 7.5,
          alignment: "right",
          bold: true
          // lineHeight: 2
        },
        textBody3: {
          fontSize: 7.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textBody4: {
          fontSize: 8.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textTotales: {
          bold: true,
          fontSize: 7.5,
          alignment: "right",
        },
        textCentrado: {
          fontSize: 7.5,
          alignment: "center",
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
        textBody1SinBold: {
          fontSize: 7.5,
        },
        tables2: {
          fontSize: 7.5,
        },
      },
    };

    //pdfMake.createPdf(docDefinition).open({}, window);
    pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
      setPdfUrl(dataUrl);
    });
  };
  
  return (
    <Dialog
      visible={showDialogFormato}
      onHide={() => setShowDialogFormato(false)}
      style={{ width: '90vw' }}
      maximizable
      modal
    >
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="Formato Inscripción"
          style={{
            width: '100%',
            height: '80vh',
            border: 'none'
          }}
        />
      )}
    </Dialog>
  );
};

export default FormatoInscripcionPDF;
